import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const StyledMenuButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#1F2937",
  color: "#fff",
  fontWeight: 600,
  padding: "0.5rem 1rem",
  borderRadius: "0.75rem",
  boxShadow: "none",
  width: "16rem",
  justifyContent: "space-between",
  textTransform: "none",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  border: "1px solid #4B5563",
  "&:hover": {
    backgroundColor: "#374151",
    boxShadow: "none",
  },
  "&:focus": {
    outline: "none",
    boxShadow: "none",
  },
  "&:active": {
    backgroundColor: "#1F2937",
    boxShadow: "none",
  },
}));

export default StyledMenuButton;
